import { render, staticRenderFns } from "./AdminCourses.vue?vue&type=template&id=14e37224&"
import script from "./AdminCourses.vue?vue&type=script&lang=js&"
export * from "./AdminCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports